import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const createWorker = async () => {
  try {
    let payload = {
      worker_type: "standard",
    };
    let { status } = await axios.post(`/v1/worker`, payload);
    if (status === 201) {
      addNotification({
        title: "Techforce.ai",
        message: "working on creating worker, please wait...",
        type: "success",
      });
    }
    return status;
  } catch (e) {
    console.log("error while creating worker ....", e);
    let {
      response: { status },
    } = e;
    if (status === 402) {
      addNotification({
        title: "Techforce.ai",
        message: "Please upgrade your plan to create new worker",
        type: "info",
      });
    } else if (status === 403) {
      addNotification({
        title: "Techforce.ai",
        message: "You don't have enough permission to create worker",
        type: "warning",
      });
    }
    return status;
  }
};
